import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Card, Result } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import logo from '../../assets/powered_by_xantage.png';
import passwordResetService from '../../services/passwordResetService';
import logger from '../../utils/logger';

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setEmail(values.email);

      await passwordResetService.forgotPassword(values.email);

      setEmailSent(true);
    } catch (error) {
      logger.error('Failed to send reset email:', error);
      // Always show success message for security (prevent email enumeration)
      setEmailSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, var(--rlc-surface-inverse-alt) 0%, var(--rlc-surface-inverse) 100%)',
        padding: '20px'
      }}>
        <Card style={{ maxWidth: 500, width: '100%', borderRadius: 8 }}>
          <Result
            status="success"
            title="Check Your Email"
            subTitle={
              <div>
                <p>
                  If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly.
                </p>
                <p style={{ marginTop: 16, fontSize: '13px', color: 'var(--rlc-text-secondary)' }}>
                  Didn't receive the email? Check your spam folder or try again.
                </p>
              </div>
            }
            extra={[
              <Link to="/login" key="login">
                <Button type="primary" icon={<ArrowLeftOutlined />}>
                  Return to Login
                </Button>
              </Link>,
              <Button
                key="resend"
                onClick={() => {
                  setEmailSent(false);
                  form.resetFields();
                }}
              >
                Try Another Email
              </Button>
            ]}
          />

          <div className="auth-footer">
            <img src={logo} alt="Powered by Xantage" className="powered-by-logo" />
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, var(--rlc-surface-inverse-alt) 0%, var(--rlc-surface-inverse) 100%)',
      padding: '20px'
    }}>
      <Card style={{ maxWidth: 450, width: '100%', borderRadius: 8 }}>
        <div className="auth-header">
          <h2>Forgot Password?</h2>
          <p style={{ color: 'var(--rlc-text-secondary)', marginTop: 8 }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please enter your email address' },
              { type: 'email', message: 'Please enter a valid email address' }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Email address"
              size="large"
              autoFocus
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
            >
              Send Reset Link
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <Link to="/login">
              <Button type="link" icon={<ArrowLeftOutlined />}>
                Back to Login
              </Button>
            </Link>
          </div>
        </Form>

        <div className="auth-footer">
          <img src={logo} alt="Powered by Xantage" className="powered-by-logo" />
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;
